import { GPS_Data, MapLike, PossibleBusinessObject, TypedPayloadMessageType, ValidBusinessObject } from '@iotv/iotv-v3-types'

import { GeofencePointsType, isGeofencePointsType } from '../types/ModelTypes'
import { IsLocatableByPosition } from './Interfaces/ModelInterfaces'
import { ModelCommon } from './ModelCommon'

const typeName = 'ThingShadowState'

const debug = process.env.REACT_APP_DEBUG && false

export interface IThingShadowState<ReportedType extends MapLike<any> = MapLike<any>, CalculatedType extends MapLike<any> = MapLike<any>> {
  metrics: ReportedType | undefined
  calculated: CalculatedType | undefined
  getLatLon: () => GeofencePointsType | GPS_Data | undefined
  mergePayload: (newPayload: TypedPayloadMessageType<ReportedType, CalculatedType>) => ThingShadowState<ReportedType, CalculatedType>
  payload: TypedPayloadMessageType<ReportedType, CalculatedType>
}

class ThingShadowState<ReportedType extends MapLike<any> = MapLike<any>, CalculatedType extends MapLike<any> = MapLike<any>>
  extends ModelCommon
  implements IThingShadowState<ReportedType, CalculatedType>, IsLocatableByPosition
{
  constructor(ob: PossibleBusinessObject) {
    super(typeName, ob)
    this.payload = ob?.payload?.state ? ob.payload : { state: { reported: {} } }
  }

  get metrics() {
    return this.payload.state.reported
  }

  set metrics(metrics: ReportedType | undefined) {
    console.log('setting metric', metrics)
    this.payload.state.reported = { ...this.payload.state.reported, ...metrics }
  }

  get calculated() {
    return this.payload.state.calculated
  }

  timestamp?: number

  getLatLon(): GeofencePointsType | GPS_Data | undefined {
    let res = undefined
    if (this.payload.state?.reported?.position) {
      const pos = this.payload.state.reported.position
      if (isGeofencePointsType(pos)) res = pos
      else {
        console.log(`could not get posiition on Geofence ${this.name}, with `, this.payload.state.reported.position)
      }
    }

    return res
  }

  // sk is latestThingShadowState then we want to capture states from muliple device type messages
  mergePayload(newPayload: TypedPayloadMessageType<ReportedType, CalculatedType>) {
    debug && console.log('Merging paylaods ', { newPayload, this: this })
    if (newPayload?.state?.reported) {
      //this would add existing field from old payload into non existing fields cf: rolls moves in v[zero]15
      // Object.assign(this.payload.state.reported, newPayload.state.reported);
      debug && console.log('We are not merging Reported')
    }
    if (newPayload?.state?.calculated) {
      if (!this.payload.state.calculated) {
        this.payload.state.calculated = newPayload.state.calculated
      } else {
        Object.assign(this.payload.state.calculated, newPayload.state.calculated)
      }
    }
    // don't merge timestamps, originally this was because we wanted to update latest, but now that is not the case and will repeat lss timestamp on updates
    // if (newPayload?.timestamp) {
    //     this.payload.timestamp = newPayload.timestamp;
    // }
    this.timestamp = Math.max(this.timestamp ?? 0, newPayload.timestamp ?? 0) // This is not the payload timestamp it is the ThingShadowState
    return this
  }

  payload: TypedPayloadMessageType<ReportedType, CalculatedType>
}

export { ThingShadowState }
